export const SEARCH_INPUT_ROOT_DESKTOP = 'search-input-root-desktop';
export const SEARCH_INPUT_ROOT_MOBILE = 'search-input-root-mobile';
export const SEARCH_INPUT_BOX = 'search-input-box';
export const SEARCH_INPUT = 'search-input';
export const SEARCH = 'search';
export const SEARCH_INPUT_CLEAR = 'search-input-clear';
export const BACKDROP = 'backdrop';
